// extracted by mini-css-extract-plugin
module.exports = {"quizIntro":"shop-all_quizIntro__AK8HG","btnGold":"shop-all_btnGold__eZRlq"};